import { render } from "./Settings.vue?vue&type=template&id=68eb3510&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"
script.render = render

export default script